import React from 'react';
import styles from '@/styles/components/ErrorLine.module.css';

const ErrorLine: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={styles.errorLine}>
    <img src="/icons/close.svg" alt="error" className={styles.errorIcon} />
    {children}
  </div>
);

export default ErrorLine; 